var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPptx = function SvgPptx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 49 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pptx_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.662 46.282h32.571a.86.86 0 0 0 .857-.857V11.997h-7.714a2.575 2.575 0 0 1-2.571-2.572V1.711H13.662a.86.86 0 0 0-.857.857v42.857a.86.86 0 0 0 .857.857"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m45.86 10.285-7.36-7.36v6.503a.86.86 0 0 0 .857.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "M48.054 10.034 38.773.75a2.6 2.6 0 0 0-1.818-.753h-23.29a2.575 2.575 0 0 0-2.571 2.571v42.858a2.575 2.575 0 0 0 2.571 2.571h32.572a2.575 2.575 0 0 0 2.571-2.571V11.85c0-.686-.267-1.332-.754-1.818m-9.532-7.11 7.36 7.36H39.38a.86.86 0 0 1-.858-.857zm-24.857 43.36h32.572a.86.86 0 0 0 .857-.857V11.998h-7.715a2.575 2.575 0 0 1-2.571-2.571V1.712H13.665a.86.86 0 0 0-.857.857v42.858c0 .473.384.857.857.857",
    clipRule: "evenodd",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED6C47",
    d: "m33.373 27.427-1.714-1.714h-3.43l-1.713 1.714v5.097a8.532 8.532 0 0 0 12.917.965 8.57 8.57 0 0 0 2.511-6.062z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF8F6B",
    d: "M26.516 22.33v5.097h6.857v-8.571a8.53 8.53 0 0 0-6.857 3.474"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC7B5",
    d: "M35.078 17.14a8.57 8.57 0 0 1 8.572 8.572h-8.572z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C43E1C",
    d: "M3.384 39.428H22.24a2.57 2.57 0 0 0 2.572-2.572V18a2.57 2.57 0 0 0-2.572-2.571H3.384a2.57 2.57 0 0 0-2.571 2.571v18.857a2.57 2.57 0 0 0 2.57 2.572"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.328 21.703q-1.26-1.098-3.627-1.098H9v13.68h2.023l.008-4.829h2.515c1.007 0 1.883-.198 2.647-.584a4.2 4.2 0 0 0 1.776-1.608c.415-.693.614-1.492.614-2.383q0-2.083-1.257-3.178zm-3.538 5.725h-2.767v-5.143h2.849c1.697 0 2.635 1.132 2.635 2.637 0 .777-.314 1.495-.754 1.9q-.667.605-1.963.606",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pptx_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.813-.002h48v48h-48z"
  })))));
};
export default SvgPptx;